// Служебные данные участника турнира (`aux` в ParticipantDto): их пишут менеджеры
// через `participants/{userId}/aux`, бэкенд только хранит и рассылает. Формат —
// фронтендный контракт, в API он `unknown`
export type ParticipantAux = {
  // игрок переведен в приватную видеокомнату (видеоконтроль, решение 2 в плане)
  privateVideoRoom?: boolean;
};

// Из API и событий приходит `unknown`: что угодно, кроме объекта, считаем пустым
export function parseParticipantAux(aux: unknown): ParticipantAux {
  if (!aux || typeof aux !== 'object' || Array.isArray(aux)) return {};
  const { privateVideoRoom } = aux as Record<string, unknown>;
  return { privateVideoRoom: privateVideoRoom === true };
}
